<template>
    <!--のし設定パーツ-->
    <div class="sh061" id="sh061" v-cloak>
        <loading :active.sync="isLoading" 
            :can-cancel="false"
            :background-color="'transparent'">
        </loading>
        <!-- のし設定 -->
        <div class="sh061-title">
            <h2>{{$t("sh061.labels.noshiSetting")}}</h2>
        </div>
        <div class="sh061-inner">
            <!--エラーメッセージ表示 -->
            <div class="errMessage">
                <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="SH061_PART"/>
            </div>
            <br>
            <!--チェックボックス -->
            <div class="sh061-select-area" id="hide_table_0" >
                <ul class="sh061-nav-ul">
                    <li v-if="dataInit.noshiShowFlg == 1">
                        <!-- のし：チェックボックス -->
                        <input name="noshiFlg" id="noshiFlg" v-model="reqModel.noshiFlg" type="checkbox" true-value="1" false-value="0"  :disabled="dataInit.dispOnly == 1 || reqModel.noshiNgKbn=='1'">
                        <label for="noshiFlg" >
                            {{$t("sh061.labels.noshiFlg")}}
                        </label>
                    </li>
                    <li v-if="dataInit.meimeiShowFlg == 1">
                        <!-- 命名札：チェックボックス -->
                        <input name="meimeiFlg" id="meimeiFlg" v-model="reqModel.meimeiFlg" type="checkbox" true-value="1" false-value="0" :disabled="dataInit.dispOnly == 1">
                        <label for="meimeiFlg" >
                            {{$t("sh061.labels.meimeiFlg")}}
                        </label>
                    </li>
                    <li v-if="dataInit.messageCardShowFlg == 1">
                        <!-- メッセージカード：：チェックボックス -->
                        <input name="messageCardFlg" id="messageCardFlg" v-model="reqModel.messageCardFlg" type="checkbox" true-value="1" false-value="0" :disabled="dataInit.dispOnly == 1">
                        <label for="messageCardFlg" >
                            {{$t("sh061.labels.messageCardFlg")}}
                        </label>
                    </li>
                </ul>
            </div>
            <!--商品情報 -->
            <div class="sh061-item-area" id="hide_table_item" >
                <div class="sh061-item-row">
                    <!--名前-->
                    <span id="itemNm_lbl" >
                        {{$t("sh061.labels.itemNm")}}
                    </span>
                    <div class="sh061-itemNm1">
                        <!-- 商品名 -->
                        <label v-if="this.reqModel.itemNm1">{{this.reqModel.itemNm1}}</label>
                    </div>
                </div>
            </div>
            <br>
            <!--のし情報 -->
            <div v-if="dataInit.noshiShowFlg == 1" class="sh061-noshiInfo-area" id="hide_table_2" >
                <div  class="sh061-body-subtitle"><h4>{{$t("sh061.labels.noshiInfo")}}</h4></div>
                <div class="sh061-noshiInfos">
                    <div class="sh061-noshicd-row ">
                        <!--のしCD -->
                        <span id="noshiCd_lbl">{{$t("sh061.labels.noshi")}}</span>
                        <div id="noshiCdDiv">
                            <select class="noshiCdSelect" 
                                id="noshiCd"
                                v-model="reqModel.noshiCd"
                                v-on:change="noshiCdChange"
                                :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                >
                                <option v-for="item in dataInit.noshiList" 
                                    :key="item.KEY" :value="item.KEY">{{item.VALUE}}</option>
                            </select>
                        </div>
                        <!--のしサイズ 
                        <span id="noshiSizeKbn_lbl" style="visibility: hidden;">
                            {{$t("sh061.labels.noshiSize")}}
                        </span>-->
                        <div id="noshiSizeKbnDiv" style="visibility: hidden; height: 0px;">
                            <select class="noshiSizeSelect"
                                data-live-search="true"
                                id="noshiSizeKbn"
                                :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                v-model="reqModel.noshiSizeKbn"
                                >
                                <option v-for="item in dataInit.noshiSizeList" 
                                    :key="item.KEY" :value="item.KEY">{{item.VALUE}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="sh061-mizuHikiKbn-row" style="visibility: hidden;height: 0;">
                        <!--水引 -->
                        <span id="mizuHikiKbn_lbl"> 
                            {{$t("sh061.labels.mizuHikiKbn")}}
                        </span>
                        <div id="mizuHikiKbnDiv">
                            <select class="mizuHikiKbnSelect" 
                                id="mizuHikiKbn"
                                :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                v-on:change="mizuHikiKbnChange"
                                v-model="reqModel.mizuHikiKbn"
                                >
                                <option v-for="item in dataInit.mizuHikiKbnList" 
                                    :key="item.KEY" :value="item.KEY">{{item.VALUE}}</option>
                            </select>
                        </div>
                    </div>
                    <!--包装紙 -->
                    <div class="sh061-wappingKbn-row" style="visibility: hidden; height: 0;">
                        <span id="wappingKbn_lbl"  >
                            {{$t('sh061.labels.housousi')}}
                        </span>
                        <div id="wappingKbnDiv">
                            <select class="wappingKbnSelect" 
                                data-live-search="true"
                                id="wappingKbn"
                                :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                v-model="reqModel.wappingKbn"
                                v-on:change="wappingKbnChange"
                                >
                                <option v-for="item in dataInit.wappingKbnList" 
                                    :key="item.KEY" :value="item.KEY">{{item.VALUE}}</option>
                            </select>
                        </div>
                        <!--包装紙枚数-->
                        <span id="wappingPages_lbl">
                            {{$t('sh061.labels.wappingPages')}}
                        </span>
                        <div id="wappingPagesDiv">
                            <input-check v-model="reqModel.wappingPages" 
                                id="wappingPages"
                                class="wappingPagesInput"
                                :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0' || reqModel.wappingKbn=='0' "
                                :maxlength="4"
                                size="4"  />
                        </div>
                    </div>
                    <!--表書き１-->
                    <div class="sh061-omotegaki1-row">
                        <span id="omoteGaki1_lbl">
                            {{$t('sh061.labels.omotegaki1')}}
                        </span>
                        <div id="omoteGaki1Div">
                            <input-check v-model="reqModel.omoteGaki1" 
                                id="omoteGaki1"
                                class="omoteGaki1Input"
                                :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                :maxlength="24"
                                size="30"
                                />
                        </div>
                    </div>
                    <!--表書き２-->
                    <div class="sh061-omotegaki2-row">
                        <span id="omotegaki2_lbl" >
                            {{$t('sh061.labels.omotegaki2')}}
                        </span>
                        <div id="omoteGaki2Div">
                            <input-check v-model="reqModel.omoteGaki2" 
                                id="omoteGaki2"
                                class="omoteGaki2Input"
                                :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                :maxlength="24"
                                size="30"
                                />
                        </div>
                    </div>
                    <!--表書き３-->
                    <div class="sh061-omotegaki3-row">
                        <span id="omotegaki3_lbl" >
                            {{$t('sh061.labels.omotegaki3')}}
                        </span>
                        <div id="omoteGaki3Div">
                            <input-check v-model="reqModel.omoteGaki3" 
                                id="omoteGaki3"
                                class="omoteGaki3Input"
                                :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                :maxlength="24"
                                size="30"
                                />
                        </div>
                    </div>
                    <!--種別-->
                    <div class="sh061-syubetu-row">
                        <div class="sh061-syubetu1-inline">
                            <input class="sh061syubetu1Input" 
                                type="radio" id="syubetu1" name="syubetu" 
                                :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                value="1" @change="syubetuChanged" v-model="reqModel.syubetu" >
                            <!-- 個人１名 -->
                            <label id="syubetu1_lbl" for="syubetu1">
                                {{$t("sh061.labels.syubetu1")}}</label>
                        </div>

                        <div class="sh061-syubetu2-inline">
                            <input class="sh061syubetu2Input" 
                                type="radio" id="syubetu2" name="syubetu" 
                                :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                value="2" @change="syubetuChanged" v-model="reqModel.syubetu"  >
                            <!-- 名のみ連名 -->
                            <label id="syubetu2_lbl" for="syubetu2">
                                {{$t("sh061.labels.syubetu2")}}</label>
                        </div>
                        
                        <div class="sh061-syubetu3-inline">
                            <input class="sh061syubetu3Input" 
                                type="radio" id="syubetu3" name="syubetu" 
                                :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                value="3" @change="syubetuChanged" v-model="reqModel.syubetu"  >
                            <!-- 個人連名 -->
                            <label id="syubetu3_lbl" for="syubetu3">
                                {{$t("sh061.labels.syubetu3")}}</label>
                        </div>

                        <div class="sh061-syubetu4-inline">
                            <input class="sh061syubetu4Input" 
                                type="radio" id="syubetu4" name="syubetu" 
                                :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                value="4" v-model="reqModel.syubetu"  >
                            <!-- ルビ付き -->
                            <label id="syubetu4_lbl" for="syubetu4">
                                {{$t("sh061.labels.syubetu4")}}</label>
                        </div>
                        <div class="sh061-syubetu5-inline">
                            <input class="sh061syubetu5Input" 
                                type="radio" id="syubetu5" name="syubetu" 
                                :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                value="5" v-model="reqModel.syubetu"  >
                            <!-- 法人 -->
                            <label id="syubetu5_lbl" for="syubetu5">
                                {{$t("sh061.labels.syubetu5")}}</label>
                        </div>
                    </div>

                    <!--種別１，２，３-->
                    <div v-show="reqModel.syubetu=='1' || reqModel.syubetu=='2' || reqModel.syubetu=='3'">
                        <!--姓１，名１-->
                        <div class="sh061-simeiSei1-row" >
                            <span id="simeiSei1_lbl"  >
                                {{$t('sh061.labels.sei1')}}
                            </span>
                            <div id="simeiSei1Div">
                                <input-check v-model="reqModel.simeiSei1" 
                                    id="simeiSei1"
                                    class="simeiSei1Input"
                                    :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                    :maxlength="12"  />
                            </div>
                            <span id="simeiMei1_lbl"  >
                                {{$t('sh061.labels.mei1')}}
                            </span>
                            <div id="simeiMei1Div">
                                <input-check v-model="reqModel.simeiMei1" 
                                    id="simeiMei1"
                                    class="simeiMei1Input"
                                    :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                    :maxlength="12"
                                    size="20"  />
                            </div>
                        </div>
                        <!--姓2，名2-->
                        <div class="sh061-simeiSei2-row" >
                            <span id="simeiSei2_lbl"  >
                                {{$t('sh061.labels.sei2')}}
                            </span>
                            <div id="simeiSei2Div">
                                <input-check v-model="reqModel.simeiSei2" 
                                    id="simeiSei2"
                                    class="simeiSei2Input"
                                    :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0' || reqModel.syubetu=='1' || reqModel.syubetu=='2'"
                                    :maxlength="12"
                                    size="20"  />
                            </div>
                            <span id="simeiMei2_lbl"  >
                                {{$t('sh061.labels.mei2')}}
                            </span>
                            <div id="simeiMei2Div">
                                <input-check v-model="reqModel.simeiMei2" 
                                    id="simeiMei2"
                                    class="simeiMei2Input"
                                    :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0' || reqModel.syubetu=='1' "
                                    :maxlength="12"
                                    size="20"  />
                            </div>
                        </div>
                        <!--姓3，名3-->
                        <div class="sh061-simeiSei3-row" >
                            <span id="sei3_lbl"  >
                                {{$t('sh061.labels.sei3')}}
                            </span>
                            <div id="simeiSei3Div">
                                <input-check v-model="reqModel.simeiSei3" 
                                    id="simeiSei3"
                                    class="simeiSei3Input"
                                    :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0' || reqModel.syubetu=='1' || reqModel.syubetu=='2'"
                                    :maxlength="12"
                                    size="20"  />
                            </div>
                            <span id="mei3_lbl"  >
                                {{$t('sh061.labels.mei3')}}
                            </span>
                            <div id="simeiMei3Div">
                                <input-check v-model="reqModel.simeiMei3" 
                                    id="simeiMei3"
                                    class="simeiMei3Input"
                                    :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0' || reqModel.syubetu=='1' "
                                    :maxlength="12"
                                    size="20"  />
                            </div>
                        </div>
                        <!--姓4，名4-->
                        <div class="sh061-simeiSei4-row" >
                            <span id="sei4_lbl">
                                {{$t('sh061.labels.sei4')}}
                            </span>
                            <div id="simeiSei4Div">
                                <input-check v-model="reqModel.simeiSei4" 
                                    id="simeiSei4"
                                    class="simeiSei4Input"
                                    :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0' || reqModel.syubetu=='1' || reqModel.syubetu=='2'"
                                    :maxlength="12"
                                    size="20"  />
                            </div>
                            <span id="mei4_lbl"  >
                                {{$t('sh061.labels.mei4')}}
                            </span>
                            <div id="simeiMei4Div">
                                <input-check v-model="reqModel.simeiMei4" 
                                    id="simeiMei4"
                                    class="simeiMei4Input"
                                    :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0' || reqModel.syubetu=='1' "
                                    :maxlength="12"
                                    size="20"  />
                            </div>
                        </div>
                        <!--姓5，名-->
                        <div class="sh061-simeiSei5-row" >
                            <span id="sei5_lbl"  >
                                {{$t('sh061.labels.sei5')}}
                            </span>
                            <div id="simeiSei5Div">
                                <input-check v-model="reqModel.simeiSei5" 
                                    id="simeiSei5"
                                    class="simeiSei5Input"
                                    :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0' || reqModel.syubetu=='1' || reqModel.syubetu=='2'"
                                    :maxlength="12"
                                    size="20"  />
                            </div>
                            <span id="mei5_lbl"  >
                                {{$t('sh061.labels.mei5')}}
                            </span>
                            <div id="simeiMei5Div">
                                <input-check v-model="reqModel.simeiMei5" 
                                    id="simeiMei5"
                                    class="simeiMei5Input"
                                    :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0' || reqModel.syubetu=='1' "
                                    :maxlength="12"
                                    size="20"  />
                            </div>
                        </div>
                    </div>
                    

                    <!--種別４-->
                    <div v-show="reqModel.syubetu=='4'" >
                        <!--名前１ルビ１-->
                        <div class="sh061-rubi1-row" >
                            <span id="namae1_lbl" >
                                {{$t('sh061.labels.namae1')}}
                            </span>
                            <div id="namae1Div">
                                <input-check v-model="reqModel.namae1" 
                                    id="namae1"
                                    class="namae1Input"
                                    :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                    :maxlength="12"
                                    size="20"  />
                            </div>
                            <span id="rubi1_lbl" >
                                {{$t('sh061.labels.rubi1')}}
                            </span>
                            <div id="rubi1Div">
                                <input-check v-model="reqModel.rubi1" 
                                    id="rubi1" 
                                    class="rubi1Input"
                                    :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                    :maxlength="12"
                                    size="20"  />
                            </div>
                        </div>

                        <!--名前２ルビ２-->
                        <div class="sh061-rubi2-row" >
                            <span id="namae2_lbl"  >
                                {{$t('sh061.labels.namae2')}}
                            </span>
                            <div id="namae2Div">
                                <input-check v-model="reqModel.namae2" 
                                    id="namae2"
                                    class="namae2Input"
                                    :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                    :maxlength="12"
                                    size="20" />
                            </div>
                            <span id="rubi2_lbl" >
                                {{$t('sh061.labels.rubi2')}}
                            </span>
                            <div id="rubi2Div">
                                <input-check v-model="reqModel.rubi2" 
                                    id="rubi2"
                                    class="rubi2Input"
                                    :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                    :maxlength="12"
                                    size="20"  />
                            </div>
                        </div>

                        <!--名前３ルビ３-->
                        <div class="sh061-rubi3-row" >
                            <span id="namae3_lbl">
                                {{$t('sh061.labels.namae3')}}
                            </span>
                            <div id="namae3Div">
                                <input-check v-model="reqModel.namae3" 
                                    id="namae3"  
                                    class="namae3Input"
                                    :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                    :maxlength="12"
                                    size="20"  />
                            </div>
                            <span id="rubi3_lbl" >
                                {{$t('sh061.labels.rubi3')}}
                            </span>
                            <div id="rubi3Div">
                                <input-check v-model="reqModel.rubi3" 
                                    id="rubi3"  
                                    class="rubi3Input"
                                    :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                    :maxlength="12"
                                    size="20"  />
                            </div>
                        </div>
                    </div>
                    

                    <!--種別５-->
                    <div v-show="reqModel.syubetu=='5'">
                        <!--会社種別-->
                        <div class="sh061-compSyubetu-row" >
                            <span id="compSyubetuCd_lbl" >
                                {{$t('sh061.labels.compSyubetu')}}
                            </span>
                            <div class="sh061-compSyubetu-inline">
                                <input class="compSyubetu1Input" 
                                    type="radio" id="compSyubetu1" name="compSyubetuCd" 
                                    :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                    value="1" v-model="reqModel.compSyubetuCd"  >
                                <!-- 前株 -->
                                <label id="compSyubetu1_lbl" for="compSyubetu1">
                                    {{$t("sh061.labels.compSyubetu1")}}</label>
                            </div>
                            <div class="sh061-compSyubetu-inline">
                                <input class="compSyubetu2Input" 
                                    type="radio" id="compSyubetu2" name="compSyubetuCd" 
                                    :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                    value="2" v-model="reqModel.compSyubetuCd"  >
                                <!-- 後株 -->
                                <label id="compSyubetu2_lbl"  for="compSyubetu2">
                                    {{$t("sh061.labels.compSyubetu2")}}</label>
                            </div>
                            <div >
                                <input-check v-model="reqModel.compSyubetuNm" 
                                    id="compSyubetuNm"  
                                    class="compSyubetuNmInput"
                                    :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                    :maxlength="8"
                                    size="20"  />
                            </div>
                            <div >
                                <select class="compSyubetuSelect" 
                                    v-on:change="compSyubetuChange"
                                    :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                    >
                                    <option v-for="item in dataInit.compKindList" 
                                        :key="item.KEY" :value="item.KEY">{{item.VALUE}}</option>
                                </select>
                            </div>
                        </div>
                        <!--会社名-->
                        <div class="sh061-compNm-row" >
                            <span id="compNm_lbl" >
                                {{$t('sh061.labels.compNm')}}
                            </span>
                            <div id="compNmDiv">
                                <input-check v-model="reqModel.compNm" 
                                    id="compNm"  
                                    class="compNmInput"
                                    :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                    :maxlength="40"
                                    size="50"  />
                            </div>
                        </div>
                        <!--部署名-->
                        <div class="sh061-compBusyo-row" >
                            <span id="compBusyo_lbl">
                                {{$t('sh061.labels.compBusyo')}}
                            </span>
                            <div id="compBusyo1Div">
                                <input-check v-model="reqModel.compBusyo1" 
                                    name="compBusyo1"
                                    id="compBusyo1"  
                                    class="compBusyo1Input"
                                    :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                    :maxlength="50"
                                    size="50"  />
                            </div>
                            <div id="compBusyo2Div">
                                <input-check v-model="reqModel.compBusyo2" 
                                    name="compBusyo2"
                                    id="compBusyo2"  
                                    class="compBusyo2Input"
                                    :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                    :maxlength="50"
                                    size="50"  />
                            </div>
                        </div>
                        <!--肩書-->
                        <div class="sh061-compKatagaki-row" >
                            <span id="compKatagaki_lbl" >
                                {{$t('sh061.labels.compKatagaki')}}
                            </span>
                            <div id="compKatagakiDiv">
                                <input-check v-model="reqModel.compKatagaki" 
                                    id="compKatagaki"  
                                    class="compKatagakiInput"
                                    :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                    :maxlength="20"
                                    size="30"  />
                            </div>
                            <div id="compKatagakiSelectDiv">
                                <select class="compKatagakiSelect" 
                                        v-on:change="compKatagakiChange"
                                        :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                        >
                                    <option v-for="item in dataInit.compKatagakiList" 
                                        :key="item.KEY" :value="item.KEY">{{item.VALUE}}</option>
                                </select>
                            </div>
                        </div>
                        <!--個人-->
                        <div class="sh061-compKojinNm-row" >
                            <span id="compKojinNm_lbl"  >
                                {{$t('sh061.labels.compKojinNm')}}
                            </span>
                            <div id="compKojinNm1Div">
                                <input-check v-model="reqModel.compKojinNm1" 
                                    id="compKojinNm1"  
                                    class="compKojinNm1Input"
                                    :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                    :maxlength="12"
                                    size="20"  />
                            </div>
                            <div id="compKojinNm2Div">
                                <input-check v-model="reqModel.compKojinNm2" 
                                    id="compKojinNm2"  
                                    class="compKojinNm2Input"
                                    :disabled="dataInit.dispOnly == 1 || reqModel.noshiFlg=='0'"
                                    :maxlength="12"
                                    size="20"  />
                            </div>
                        </div>
                    </div>
					<!--のし枚数を入力する -->
					<div class="sh061-noshicd-row " v-show="dataInit.noshiCountInputFlg=='1'">
						<span id="noshiPages_input_lbl">
                            {{$t("sh061.labels.noshiPages")}}
                        </span>
						<div>
					        <select class="noshiCdSelect" 
					                data-live-search="true"
									v-model="reqModel.noshiPages"
					                v-on:change="noshiCountInputChange"
					                :disabled="dataInit.noshiCountInputFlg=='0'"
					                >
					            <option v-for="count in reqModel.qty" 
					                :key="count" :value="count">{{count}}</option>
					        </select>
					    </div>
					</div>
                </div>
            </div>
            <br>

            <!--命名札-->
            <div v-if="dataInit.meimeiShowFlg == 1" class="sh061-body-area" id="hide_table_3" >
                <div  class="sh061-body-subtitle"><h4>{{$t("sh061.labels.meimeiInfo")}}</h4></div>
                <div class="sh061-meimei-row">
                    <!--名前-->
                    <span id="meimeiNm_lbl" >
                        {{$t('sh061.labels.meimeiNm')}}
                    </span>
                    <div id="meimeiNmDiv">
                        <input-check v-model="reqModel.meimeiNm" 
                            id="meimeiNm"  
                            class="meimeiNmInput"
                            :disabled="dataInit.dispOnly == 1 || reqModel.meimeiFlg=='0'"
                            :maxlength="16"  />
                    </div>
                    <!--ふりがな-->
                    <span id="meimeiKana_lbl"  >
                            {{$t('sh061.labels.meimeiKana')}}
                    </span>
                    <div id="meimeiKanaDiv">
                        <input-check v-model="reqModel.meimeiKana" 
                            id="meimeiKana"  
                            class="meimeiKanaInput"
                            :disabled="dataInit.dispOnly == 1 || reqModel.meimeiFlg=='0'"
                            :maxlength="16"  />
                    </div>
                </div>
            </div>
            <br>

            <!--メッセージカード-->
            <div v-if="dataInit.messageCardShowFlg == 1" class="sh061-body-area" id="hide_table_3" >
                <div  class="sh061-body-subtitle">
                    <h4>{{$t("sh061.labels.messageCardInfo")}}</h4>
                </div>
                <div class="sh061-message-row">
                    <select class="messageCardCdSelect" 
                        elementId="messageCardCd"
                        v-model="reqModel.messageCardCd"
                        v-on:change="messageCardChange"
                        :disabled="dataInit.dispOnly == 1 || reqModel.messageCardFlg=='0'"
                        >
                        <option v-for="item in dataInit.messageCardList" 
                            :key="item.KEY" :value="item.KEY">{{item.VALUE}}</option>
                    </select>
                </div>
                <div class="sh061-message-row">
                    <textarea v-model="reqModel.messageContents" 
                        id="messageContents"
                        class="messageContentsInput"
                        type="text" 
                        :maxlength="300"
                        :disabled="dataInit.dispOnly == 1 || reqModel.messageCardFlg=='0'"
                        rows="4">
                    </textarea>
                </div>
            </div>

            <div class="sh061-Submit-row">
                <!-- 次へ進む -->
                <button @click="gotobak" type="button">{{$t("common.buttons.backtothepreviouspage")}}</button>
                <!-- 変更 -->
                <button v-if="! dataInit.dispOnly == 1" @click="submit" type="button">{{$t("common.buttons.change")}}</button>
            </div>
        </div>
        
        <!--メッセージ表示するため、入れるもの -->
        <div hidden>
            <span id="allFlg_lbl" >{{$t('sh061.labels.allFlg')}}</span>
            <span id="compSyubetuNm_lbl" >{{$t('sh061.labels.compSyubetuNm')}}</span>
            <span id="messageContents_lbl" >{{$t('sh061.labels.messageContents')}}</span>
        </div>
        
    </div>
</template>
<script>
/* 
* Import libs and componnents
*/
import $ from 'jquery';
import common from "assets/js/common";
import axios from "assets/js/request";
import Loading from 'vue-loading-overlay';
import InputCheck from "components/InputCheck";
import AlertConfirm from "components/AlertConfirm";
import EventBus from "assets/js/eventBus";
import SiteConstants from 'assets/const/SiteConstants.json';
import Message from 'components/MessageEcSite';

export default {
    /* 
    * Name of component
    */
    name: "SH061ShopperItemInfoNoshi",
    props:{
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    /* 
    * Declare components
    */
    components: {
        InputCheck,
        Loading,
        AlertConfirm,
        Message
    },/* 
    * Declare variable and set default value
    */
    data() {
        return {
            dataInit:{
                noshiList:[],
                compKindList:[],
                compKatagakiList:[],
                messageCardList:[],
                itemInfo: {
                    MSG_CARD_NG_KBN_NM: '',
                    ITEM_CD: '',
                    NOSHI_NG_KBN_NM: '',
                    WRAPPING_NG_KBN_NM: '',
                    S_ITEM_CD: '',
                    ITEM_NM1: ''
                }
            },
            reqModel:{
                tdkNo: null,
                orderNo: null,
                lineNo: null,
                itemCd: null,
                syubetu:'1',
                noshiFlg:'1',
                meimeiFlg:'0',
                messageCardFlg:'0',
                copyFlg:'0',
                allTdkFlg:'0'
            },
            SH061_PART:'sh061',
            SiteConstants: SiteConstants,
            listMessValid:[],
            mapMessValid:[],
            listIdErr:[],
            NO_CART_ERR : "001",
            isLoading: false
        }
    },
    /* 
    * Initialize
    */
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        if (_this.ptInitData){
            _this.isLoading = true;
            try {
                if(_this.ptInitData.status != 'OK'){
                    if(_this.ptInitData.respCode == _this.NO_CART_ERR){
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query:{pageNo:2}});
                        return;
                    }
                }

                _this.dataInit = _this.ptInitData;
                _this.reqModel = Object.assign({}, _this.reqModel, _this.ptInitData.reqModel);
                
                _this.$forceUpdate();
            } catch (error) {
                common.errorAPI(error);
            }finally{
                _this.isLoading = false;
            }
        }else{
            _this.isLoading = true;
            var reqModel = {
                itemCd:this.reqModel.itemCd,
                tdkNo:this.reqModel.tdkNo,
                lineNo:this.reqModel.lineNo,
                dispOnly:this.reqModel.dispOnly
            }
            axios.post(_this.$UrlConstants.ECSITE +_this.$UrlConstants.SH061 + _this.$UrlConstants.DO_INIT,reqModel).then(function(response) {
                if(response.data.status != 'OK'){
                    if(response.data.respCode == _this.NO_CART_ERR){
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 2}});
                        return;
                    }
                }

                _this.dataInit = response.data;
                _this.reqModel = Object.assign({}, _this.reqModel, response.data.reqModel);
                
                _this.$forceUpdate();
                _this.isLoading = false;
            }).catch(function(error) {
                _this.isLoading = false;
                common.errorAPI(error);
            });
        }

        EventBus.$on("closed", function() {

        });

    },
    /* 
    * Methods
    */
    methods: {
        syubetuChanged() {
            var _this = this;

            if(_this.reqModel.syubetu == '1'){
                _this.reqModel.simeiSei2 = '';
                _this.reqModel.simeiSei3 = '';
                _this.reqModel.simeiSei4 = '';
                _this.reqModel.simeiSei5 = '';
                
                _this.reqModel.simeiMei2 = '';
                _this.reqModel.simeiMei3 = '';
                _this.reqModel.simeiMei4 = '';
                _this.reqModel.simeiMei5 = '';
            }
            if(_this.reqModel.syubetu == '2'){
                _this.reqModel.simeiSei2 = '';
                _this.reqModel.simeiSei3 = '';
                _this.reqModel.simeiSei4 = '';
                _this.reqModel.simeiSei5 = '';

            }
        },
        // のしコードよりのしサイズ区分一覧取得,表書き設定
        noshiCdChange(e){
            var value = e.target.value;
            var noshiList = this.dataInit.noshiList;
            var mujiNoshiCd = '';
            var mujiNoshiObj = noshiList.find(el => el['VALUE'] === '無地のし');
            mujiNoshiCd = mujiNoshiObj ? mujiNoshiObj['KEY'] : '';
            for (var i = 0; i < noshiList.length; i++) {
                if (noshiList[i].KEY == value){
                    //初期値設定
                    //無地のしの場合、表書き、名入れを反映しないように
                    if(mujiNoshiCd == value) {
                        this.reqModel.omoteGaki1 = '';
                        this.reqModel.simeiSei1 = '';
                    } else {
                        this.reqModel.omoteGaki1 = noshiList[i].OMOTEGAKI;
                        if(!this.reqModel.simeiSei1) {
                            this.reqModel.simeiSei1 = this.reqModel.kokyakuNm1;
                        }
                    }
                    this.reqModel.mizuHikiKbn = noshiList[i].MIZUHIKI_KBN;
                    this.reqModel.wappingKbn = noshiList[i].WRAPPING_KBN;
                }
            }
            this.doAjax(value);
        },
        
        /*
        * のしサイズリストの取得
        */
        doAjax: function() {
            var _this = this;
            _this.isLoading = true;

            var ajaxReqModel = {
                noshiCd:this.reqModel.noshiCd
            }

            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH061 + _this.$UrlConstants.DO_AJAX, ajaxReqModel).then(function(response) {
                _this.dataInit.noshiSizeList = response.data.noshiSizeList;
                _this.reqModel.noshiSizeKbn  = '';

                //のしCDより水引区分の初期値
                var noshiList = _this.dataInit.noshiList;
                for (var i = 0; i < noshiList.length; i++) {
                    if (noshiList[i].KEY == _this.reqModel.noshiCd){
                        //初期値設定
                        _this.reqModel.mizuHikiKbn = noshiList[i].MIZUHIKI_KBN;
                        break;
                    }
                }
                //のしサイズ初期値
                if(_this.dataInit.noshiSizeList != undefined && _this.dataInit.noshiSizeList != null && _this.dataInit.noshiSizeList.length > 0){
                    //水引区分リスト->PARAM_MARK取得
                    var mizuHikiKbnParam='';
                    for (var i = 0; i < _this.dataInit.mizuHikiKbnList.length; i++) {
                        if (_this.dataInit.mizuHikiKbnList[i].KEY == _this.reqModel.mizuHikiKbn){
                            //初期値設定
                            mizuHikiKbnParam = _this.dataInit.mizuHikiKbnList[i].PARAM_MARK;
                            break;
                        }
                    }
                    //のしサイズ
                    var defult = _this.dataInit.noshiSizeList[0].KEY;
                    for (let i = 0; i < _this.dataInit.noshiSizeList.length; i++) {
                        var item = _this.dataInit.noshiSizeList[i];
                        if(item!= undefined && !common.isNullItem(item.KEY) && item.KEY == mizuHikiKbnParam) {
                            defult = mizuHikiKbnParam;
                            break;
                        }
                    }
                    _this.reqModel.noshiSizeKbn = defult;
                }
                _this.isLoading = false;
            }).catch(function(error) {
                _this.isLoading = false;
                // eslint-disable-next-line
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined) {
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH061_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        //水引のPARAM_MARKより、のしサイズ区分を決める
        mizuHikiKbnChange(e){
            
            for (var i = 0; i < this.dataInit.mizuHikiKbnList.length; i++) {
                if (this.dataInit.mizuHikiKbnList[i].KEY == this.reqModel.mizuHikiKbn){
                    var defaultVal = this.dataInit.mizuHikiKbnList[i].PARAM_MARK;//水引のPARAM_MARKより、のしサイズ区分を決める
                    if(!common.isNullItem(defaultVal)){
                        var defult = this.dataInit.noshiSizeList[0].KEY;
                        for (let j = 0; j < this.dataInit.noshiSizeList.length; j++) {
                            var item = this.dataInit.noshiSizeList[j];
                            if(item!= undefined && !common.isNullItem(item.KEY) && item.KEY == defaultVal) {
                                defult = defaultVal;
                                break;
                            }
                        }
                        this.reqModel.noshiSizeKbn = defult;
                    }
                    break;
                }
            }
            this.$forceUpdate();
        },
        wappingKbnChange: function() {
            this.$forceUpdate();
        },
        messageCardChange(e){
            var value = e.target.value;
            var itemList = this.dataInit.messageCardList;
            for (var i = 0; i < itemList.length; i++) {
                if (itemList[i].KEY == value){
                    this.reqModel.messageContents = itemList[i].PARAM_MARK;
                }
            }
        },
        compSyubetuChange(e){
            var value = e.target.value;
            var itemList = this.dataInit.compKindList;
            for (var i = 0; i < itemList.length; i++) {
                if (itemList[i].KEY == value){
                    this.reqModel.compSyubetuNm = itemList[i].VALUE;
                    this.$forceUpdate();
                }
            }
        },
        compKatagakiChange(e){
            var value = e.target.value;
            var itemList = this.dataInit.compKatagakiList;
            for (var i = 0; i < itemList.length; i++) {
                if (itemList[i].KEY == value){
                    this.reqModel.compKatagaki = itemList[i].VALUE;
                    this.$forceUpdate();
                }
            }
        },
		noshiCountInputChange(e){
            var value = e.target.value;
			this.reqModel.noshiPages = value;
        },
        /*
        * Confirm insert
        */
        confirmInsert: function(){
            var _this = this;
            // Show alert confirm insert
            _this.isModalShow = true;
        },

        //更新処理
        submit:function(){
            var _this = this;
            _this.$emit("event-loading", true);
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.SH061_PART);

            var noshiList = _this.dataInit.noshiList;
            if(!common.isNullItem(_this.reqModel.noshiCd)){
                _this.reqModel.noshiNm = noshiList.find(el => el['KEY'] === _this.reqModel.noshiCd)['VALUE'];
            }

            axios.post(_this.$UrlConstants.ECSITE +_this.$UrlConstants.SH061 + _this.$UrlConstants.DO_UPDATE, _this.reqModel).then(function(response) {
                if(response.data.status=="OK"){
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: _this.reqModel.backPageNo,tdkSeq:_this.reqModel.tdkNo}});
                    _this.$emit("event-loading", false);
                }
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    _this.isModalShow = false;
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH061_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
                common.scrollTop();
            });
        },
        //前画面に戻る
        gotobak:function(){
            var _this = this;
            if(_this.reqModel.backPageNo == 10){
                //注文履歴(PT460)画面へ
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN
                        , query: {pageNo: 10,orderNo:_this.reqModel.backOrderNo,orderCdTypical:_this.reqModel.backOrderCdTypical,fBaFlg:_this.reqModel.backFBaFlg}
                        , params: {orderNo: _this.reqModel.backOrderNo, orderCdTypical: _this.reqModel.backOrderCdTypical, fBaFlg: _this.reqModel.backFBaFlg, requestBack: _this.reqModel.requestBack}
                    });
            }else{
                //19:届け先情報(SH030),28:届け先振分設定情報(SH041)画面へ
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: _this.reqModel.backPageNo,tdkSeq:_this.reqModel.tdkNo}});
            }
        },
        
    },
    created(){
        //渡すデータ取得
        var paramData = this.$route.params;
        if(paramData != null){
            this.reqModel = $.extend(this.reqModel, paramData);
            if(this.reqModel.kokyakuNm1 != null){
                this.reqModel.simeiSei1 = this.reqModel.kokyakuNm1;
            }
            //のし枚数 包装紙枚数 = 注文数
            if(this.reqModel.qty != null){
                this.reqModel.noshiPages = this.reqModel.qty;
                this.reqModel.wappingPages = this.reqModel.qty;
            }
            //backPageNo
            if(this.reqModel.backPageNo == null){
                this.reqModel.backPageNo = 19;
            }
        }
    },
    /*
    * Function watch
    */
    watch: {
        /*
        *  event close modal
        */
        'reqModel.copyFlg' :function(newVal, oldVal) {
            if (newVal=='0') {
                this.reqModel.allTdkFlg='0';
            }
        }
    }
}
</script>